import { z } from "zod/v4";
import {
  carrierAndServiceSchema,
  DynamicRateSelection,
} from "../integration/redo-in-shipping/shipping-rate-table";
import { InsertionPosition } from "../widget";

export enum DateOrigin {
  CARRIER_RATE = "CARRIER_RATE",
}

export enum PdpPlacementMethod {
  APP_BLOCK = "APP_BLOCK",
  THEME_EXTENSION = "THEME_EXTENSION",
}

export const DEFAULT_DELIVERY_ESTIMATE_PDP_SELECTOR =
  '[action="/cart/add"]:not(#product-form-installment):not(.installment)';
export const DEFAULT_DELIVERY_ESTIMATE_PDP_INSERT_POSITION =
  InsertionPosition.APPEND;

/**
 * Schema for carrier rate configuration in storefront delivery estimate
 */
const storefrontDeliveryEstimateCarrierRateSchema_ = z.object({
  rates: z.array(carrierAndServiceSchema).optional(),
  multipleDynamicRateSelection: z.enum(DynamicRateSelection).optional(),
});
export const storefrontDeliveryEstimateCarrierRateSchema: z.ZodType<StorefrontDeliveryEstimateCarrierRate> =
  storefrontDeliveryEstimateCarrierRateSchema_;
export type StorefrontDeliveryEstimateCarrierRate = z.infer<
  typeof storefrontDeliveryEstimateCarrierRateSchema_
>;

/**
 * Schema for date origin configuration in storefront delivery estimate
 */
const dateOriginSchema_ = z.union([
  z.object({
    origin: z.literal(DateOrigin.CARRIER_RATE),
    carrierRate: storefrontDeliveryEstimateCarrierRateSchema,
  }),
]);
export const dateOriginSchema: z.ZodType<DateOriginSettings> =
  dateOriginSchema_;
export type DateOriginSettings = z.infer<typeof dateOriginSchema_>;

/**
 * Schema for delivery estimate selector configuration
 */
const deliveryEstimateSelectorSchema_ = z.object({
  selector: z.string(),
  insertPosition: z.enum(InsertionPosition),
});
export const deliveryEstimateSelectorSchema: z.ZodType<DeliveryEstimateSelector> =
  deliveryEstimateSelectorSchema_;
export type DeliveryEstimateSelector = z.infer<
  typeof deliveryEstimateSelectorSchema_
>;

/**
 * Main schema for storefront delivery estimate settings
 */
const storefrontDeliveryEstimateSchema_ = z.object({
  enabled: z.boolean(),
  pdpPlacementMethod: z.enum(PdpPlacementMethod),
  selectors: z.array(deliveryEstimateSelectorSchema).optional(),
  dateOrigin: dateOriginSchema,
});
export const storefrontDeliveryEstimateSchema: z.ZodType<StorefrontDeliveryEstimate> =
  storefrontDeliveryEstimateSchema_;
export type StorefrontDeliveryEstimate = z.infer<
  typeof storefrontDeliveryEstimateSchema_
>;
